"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PastOrder = exports.default = void 0;

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var _react = _interopRequireWildcard(require("react"));

var _formatters = require("formatters");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _SiteLayout = babelHelpers.interopRequireDefault(require("layouts/SiteLayout"));

var _SiteNavigation = babelHelpers.interopRequireDefault(require("components/SiteNavigation"));

var _Cart = babelHelpers.interopRequireDefault(require("Cart"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _class3, _descriptor9;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || babelHelpers.typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = babelHelpers.getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = babelHelpers.getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return babelHelpers.possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PastOrderPage = (_class3 = /*#__PURE__*/function (_Component2) {
  babelHelpers.inherits(PastOrderPage, _Component2);

  var _super2 = _createSuper(PastOrderPage);

  function PastOrderPage() {
    var _this2;

    babelHelpers.classCallCheck(this, PastOrderPage);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this2, "content", _descriptor9, babelHelpers.assertThisInitialized(_this2));
    return _this2;
  }

  babelHelpers.createClass(PastOrderPage, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        id: "page-content-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        "data-cart-page": "true"
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(PastOrder, this.content))));
    }
  }]);
  return PastOrderPage;
}(_react.Component), (_descriptor9 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "content", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
exports.default = PastOrderPage;
var PastOrder = (_class = /*#__PURE__*/function (_Component) {
  babelHelpers.inherits(PastOrder, _Component);

  var _super = _createSuper(PastOrder);

  function PastOrder() {
    var _this;

    babelHelpers.classCallCheck(this, PastOrder);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this, "id", _descriptor, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "clientName", _descriptor2, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "orderDate", _descriptor3, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "orderNumber", _descriptor4, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "submittedBy", _descriptor5, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "poRefNumber", _descriptor6, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "items", _descriptor7, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "comment", _descriptor8, babelHelpers.assertThisInitialized(_this));
    return _this;
  }

  babelHelpers.createClass(PastOrder, [{
    key: "reorder",
    value: function reorder() {
      (0, _fetch.default)("data/cart/reorder", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          order: this.id
        })
      }).then(function (data) {
        return data.json();
      }).then(function (d) {
        _SiteNavigation.default.cartUpdated();

        _SiteLayout.default.current.navigate(d.target);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "block stack text height-auto",
        "data-block-type": "freeformText",
        "data-block-id": "orderReviewHeader"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "inner-content container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "order-review-header"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "inner-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "details-container"
      }, /*#__PURE__*/_react.default.createElement("p", null, this.clientName), /*#__PURE__*/_react.default.createElement("h1", null, new Date(this.orderDate).format('F j, Y')), /*#__PURE__*/_react.default.createElement("p", {
        className: "date-person"
      }, "Order #", this.orderNumber, " - Submitted by ", this.submittedBy, this.poRefNumber ? " - P.O. ".concat(this.poRefNumber) : ''), /*#__PURE__*/_react.default.createElement("a", {
        className: "btn btn-primary reorder",
        href: "javascript:void(0)",
        onClick: this.reorder
      }, "Re-Order")), /*#__PURE__*/_react.default.createElement("div", {
        className: "price-container"
      }, /*#__PURE__*/_react.default.createElement("h3", null, "Order Total"), /*#__PURE__*/_react.default.createElement("h3", {
        className: "price"
      }, (0, _formatters.formatPrice)(this.items.map(function (item) {
        return item.quantity * item.price;
      }).reduce(function (a, b) {
        return a + b;
      }), true))))))), /*#__PURE__*/_react.default.createElement("div", {
        className: "block stack text height-auto",
        "data-block-type": "freeformText",
        "data-block-id": "orderReview"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "inner-content container"
      }, /*#__PURE__*/_react.default.createElement(_Cart.default, {
        contents: this.items,
        mode: "PreviousOrder",
        previousOrder: {
          id: this.id,
          comment: this.comment
        }
      }))));
    }
  }]);
  return PastOrder;
}(_react.Component), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "clientName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "orderDate", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "orderNumber", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "submittedBy", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "poRefNumber", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "items", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "comment", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "reorder", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "reorder"), _class.prototype)), _class);
exports.PastOrder = PastOrder;